import { SignKycFormModal } from '@dealstack/frontend/investor/pages/Investment/common/checksComplete/SignKycFormModal/SignKycFormModal';
import { InstructionsCardModal } from '@dealstack/frontend/investor/pages/Investment/common/Contracts/Instructions/InstructionsCardModal';
import { PreviewKycFormModal } from '@dealstack/frontend/investor/pages/Investment/common/PreviewKycFormModal/PreviewKycFormModal';
import { InvestorKycFormsTable } from '@dealstack/frontend/investor/pages/Investment/common/InvestorKycFormsTable/InvestorKycFormsTable';
import { InheritedFormsConfirmation } from '@dealstack/frontend/investor/pages/Investment/common/InheritedFormsConfirmation/InheritedFormsConfirmation';
import { EidEasySigningModal } from '@dealstack/frontend/shared/components/EidEasySigningModal/EidEasySigningModal';
import { useJoinAndAllocationKycFormsController } from './useJoinAndAllocationKycFormsController';

export const JoinAndAllocationKycForms = () => {
	const {
		pairedForms,
		inheritedForms,
		isFormsLoaded,
		isInheritedAndLocked,
		isConfirmedInherited,
		onConfirmAllForms,
		onDismissInheritedForms,
		onResetForms,
		showWetInkModal,
		setShowWetInkModal,
		showDocumentPreviewModal,
		setShowDocumentPreviewModal,
		selectedFormPair,
		setSelectedFormPair,
		selectedInstructionFormIndex,
		setSelectedInstructionFormIndex,
		kycFormsWithInstructions,
		refreshData,
		onDelete,
		onPreview,
		onSign,
		onInstructionClick,
		kycWorkflowId,
		startSigningForm,
		signingModalProps,
	} = useJoinAndAllocationKycFormsController();

	const selectedInstructionForm =
		selectedInstructionFormIndex != null
			? kycFormsWithInstructions?.[selectedInstructionFormIndex]
			: null;

	if (!isFormsLoaded) {
		return null;
	}

	return (
		<div>
			{(isInheritedAndLocked || isConfirmedInherited) && inheritedForms ? (
				<InheritedFormsConfirmation
					inheritedForms={isConfirmedInherited ? pairedForms ?? [] : inheritedForms}
					onConfirm={onConfirmAllForms}
					onDismiss={onDismissInheritedForms}
					onReset={onResetForms}
					confirmed={isConfirmedInherited}
				/>
			) : (
				<>
					{!!pairedForms?.length && (
						<InvestorKycFormsTable
							data={pairedForms}
							onDelete={onDelete}
							onPreview={onPreview}
							onSign={onSign}
							onInstructionClick={onInstructionClick}
							onStartSigning={startSigningForm}
						/>
					)}
				</>
			)}

			{/*
				Page-level sibling, exactly as the contract flow mounts it: the post-signing refetch
				re-derives the table's columns (and, for an inherited set, swaps the table out for
				InheritedFormsConfirmation), which would unmount a cell-mounted modal mid
				success-screen. Mantine's Modal renders nothing while `isModalOpen` is false.
			*/}
			<EidEasySigningModal {...signingModalProps} />

			{showWetInkModal && !!selectedFormPair && (
				<SignKycFormModal
					onClose={() => {
						setShowWetInkModal(false);
						setSelectedFormPair(undefined);
					}}
					opened={showWetInkModal && !!selectedFormPair}
					form={selectedFormPair}
					refreshData={refreshData}
					kycWorkflowId={kycWorkflowId}
				/>
			)}

			{showDocumentPreviewModal && !!selectedFormPair ? (
				<PreviewKycFormModal
					opened={showDocumentPreviewModal && !!selectedFormPair}
					onClose={() => {
						setShowDocumentPreviewModal(false);
						setSelectedFormPair(undefined);
					}}
					form={selectedFormPair}
				/>
			) : null}

			{selectedInstructionFormIndex != null &&
				!!selectedInstructionForm &&
				!!kycFormsWithInstructions && (
					<InstructionsCardModal
						instruction={selectedInstructionForm.instruction}
						title={selectedInstructionForm.name}
						onClose={() => {
							setSelectedInstructionFormIndex(undefined);
						}}
						onNext={() => {
							setSelectedInstructionFormIndex(selectedInstructionFormIndex + 1);
						}}
						onPrev={() => {
							setSelectedInstructionFormIndex(selectedInstructionFormIndex - 1);
						}}
						disableNext={
							selectedInstructionFormIndex + 1 > kycFormsWithInstructions.length - 1
						}
						disablePrev={selectedInstructionFormIndex - 1 < 0}
					/>
				)}
		</div>
	);
};
